export const whitespacesValidator = (value: string) => !!value.trim();
